import React from 'react';


const TermsPage = () => {
    return (
    <div className="legal-page">
      <h1 className="legal-title">Text Messaging Terms & Conditions</h1>
        <div className="legal-content">
           <section className="legal-section">
            <p>By signing up for text message updates, you agree to receive customer support text messages from Panda Notify at the mobile number you provided. Message frequency may vary based on your interactions, upcoming events, or important notices from Panda Notify. Message and data rates may apply depending on your mobile carrier plan. For assistance, reply HELP or email us at help@pandanotify.com, or visit our website at https://www.pandanotify.com/privacy. You can reply STOP to opt out of text messages at any time. Text messaging opt-in data and consent will not be sold or shared with third parties or affiliates for their marketing or promotional purposes. For more information about how we collect, use, or share your data, please review our Privacy Policy.
            </p>
           </section>
            <section className="legal-section">
          <p><strong>Last Updated:</strong> December 15, 2025</p>
        </section>
        </div>
      </div>

    );
  };
  
export default TermsPage;
